// Auto version from window (set in Liquid)
const currentVersion = window.currentCollectionVersion || '0';
const versionKey = 'collectionCacheVersion';
let collectionCache = {};

// Safely check for existing version and cache
try {
  const storedVersion = sessionStorage.getItem(versionKey);
  if (storedVersion !== currentVersion) {
    sessionStorage.removeItem('cachedCollections');
    sessionStorage.setItem(versionKey, currentVersion);
  }

  const cached = sessionStorage.getItem('cachedCollections');
  collectionCache = cached ? JSON.parse(cached) : {};
} catch (e) {
  console.warn('Invalid cache data. Resetting...');
  sessionStorage.removeItem('cachedCollections');
  sessionStorage.setItem(versionKey, currentVersion);
}

document.addEventListener("DOMContentLoaded", function () {
  const tabList = document.getElementById("customTabList");
  if (!tabList) return;

  const tabLinks = tabList.querySelectorAll(".custom-tab-item");
  const ajaxContainer = document.getElementById("ajax-collection-body");

  function updateCache(url, html) {
    collectionCache[url] = html;
    sessionStorage.setItem('cachedCollections', JSON.stringify(collectionCache));
  }

  function getStickyOffset() {
    const stickyEl = document.querySelector('.custom-collection-tab-container');
    return stickyEl ? stickyEl.offsetHeight + 60 : 100;
  }

  function scrollToTopOfAjaxBody(offset = 100) {
    requestAnimationFrame(() => {
      const element = document.getElementById('ajax-collection-body');
      if (!element) return;
      const top = element.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: 'smooth' });
    });
  }

  tabLinks.forEach(link => {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      const baseUrl = this.getAttribute("href");
      const url = baseUrl + '?view=ajax';

      if (!ajaxContainer) return;

      // Show loader
      ajaxContainer.innerHTML = `
        <div class="oorla-bounce-wrapper">
          <div class="ball"></div>
          <div class="ball delay"></div>
          <div class="ball delay-2"></div>
        </div>
      `;

      // Scroll up immediately
      scrollToTopOfAjaxBody(getStickyOffset());

      if (collectionCache[baseUrl]) {
        ajaxContainer.innerHTML = collectionCache[baseUrl];
        history.pushState(null, "", baseUrl);
        scrollToTopOfAjaxBody(getStickyOffset());

        tabLinks.forEach(tab => tab.classList.remove("active"));
        this.classList.add("active");
        this.scrollIntoView({ behavior: "smooth", inline: "center" });
         // ✅ Re-run variant logic on newly loaded product cards 
        initVariantPicker();
        return;
      }

      fetch(url)
        .then(response => {
          if (!response.ok) throw new Error('Network error');
          return response.text();
        })
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");
          const newBody = doc.querySelector("#ajax-collection-body");

          if (newBody) {
            ajaxContainer.innerHTML = newBody.innerHTML;
            updateCache(baseUrl, newBody.innerHTML);
            history.pushState(null, "", baseUrl);
            scrollToTopOfAjaxBody(getStickyOffset());

            tabLinks.forEach(tab => tab.classList.remove("active"));
            this.classList.add("active");
            this.scrollIntoView({ behavior: "smooth", inline: "center" });

            document.dispatchEvent(new Event("collection:updated"));
            // ✅ Re-run variant logic on newly loaded product cards 
            initVariantPicker();
          } else {
            throw new Error("Target container not found");
          }
        })
        .catch(error => {
          ajaxContainer.innerHTML = '<div style="text-align:center;color:red;padding:50px;">Failed to load collection.</div>';
          console.error("AJAX Tab Switch Error:", error);
        });
    });
  });

  window.addEventListener("popstate", () => {
    location.reload();
  });
});
